export enum StockLocationsPermissions {
  GET_STOCK_LOCATIONS = 'stockLocations.getStockLocations',
  PERSIST_STOCK_LOCATION = 'stockLocations.persistStockLocation',
  ARCHIVE_STOCK_LOCATION = 'stockLocations.archiveStockLocation',
}
